/* @flow */
import { Container } from 'flux/utils';

import BlockedUserActions from 'actions/BlockedUserActions';
import BlockedUserStore from '../stores/BlockedUserStore';
import BlockedUserList from './BlockedUsersList.jsx';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';
import Fieldset from 'components/Fieldset.jsx';
import Legend from 'components/Legend.jsx';
import React, { Component } from 'react';

class PrivacySettingsView extends Component {
  static getStores() {
    return [BlockedUserStore];
  }

  static calculateState() {
    const blockedUsers = BlockedUserStore.getBlockedUsers();
    const loaded = BlockedUserStore.isLoaded();

    return {
      blockedUsers,
      loaded,
    };
  }

  state = {};

  componentDidMount() {
    if (!BlockedUserStore.isLoaded()) {
      BlockedUserActions.load();
    }
  }

  renderList() {
    return <BlockedUserList blockedUsers={this.state.blockedUsers} />;
  }

  renderLoadingIndicator() {
    return <CenteredLoadingIndicator />;
  }

  render() {
    return (
      <div>
        <Fieldset>
          <Legend>
            Blocked Users
            <p>
              Users you have blocked will not be able to send you
              individual messages or add you to their classes.
            </p>
          </Legend>
          {this.state.loaded ? this.renderList() : this.renderLoadingIndicator()}
        </Fieldset>
      </div>
    );
  }
}

export default Container.create(PrivacySettingsView, { pure: false });



// WEBPACK FOOTER //
// ./src/settings/components/PrivacySettingsView.jsx